"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: solid 1px ", ";\n  border-left: 8px solid ", ";\n  border-radius: 4px;\n  display: flex;\n  flex-wrap: nowrap;\n  min-height: 96px;\n  overflow: hidden;\n  padding: 12px 0;\n  position: relative;\n  max-width: 470px;\n  width: 100vw;\n\n  > div {\n    flex-shrink: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toaster = void 0;

var _stylitas = require("@creditas/stylitas");

var toaster = function toaster(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return (0, _stylitas.css)(_templateObject(), theme.bColorneutral01, theme.bColorneutral03, theme["bColor".concat(variant.toLowerCase())]);
};

exports.toaster = toaster;